import React from 'react'
import { Container, Row, Col } from 'reactstrap'

const ProgressBar = ({ label, percentage, total, totalLabel, progressColor = '#E94B4B', externalLinkOnClick }) => {
  return (
    <Container>
      <Row
        style={{
          padding: 0,
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Col>
          <p style={{ fontWeight: 800 }}>{label}</p>
          <Col style={{ padding: 0, margin: 0 }}>
            <div
              style={{
                width: '100%',
                height: '25px',
                backgroundColor: '#f7f7f7',
                borderRadius: '20px',
                position: 'relative',
              }}
            >
              <div
                style={{
                  width: `${percentage}%`,
                  height: '100%',
                  backgroundColor: progressColor,
                  borderRadius: '20px',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                }}
              />
            </div>
          </Col>
        </Col>

        <div style={{ width: 1, height: '100px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '0 10px' }} />

        <Col style={{ flex: 'none', width: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <p style={{ fontSize: 20 }}>
            <span style={{ fontWeight: 800, padding: '0 5px' }}>{total}</span> {totalLabel}
          </p>
        </Col>

        <div style={{ width: 1, height: '100px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '0 10px' }} />

        {/* <Col style={{ flex: 'none', width: '50px' }}>
          <a href="#!" style={{ cursor: 'pointer' }} onClick={externalLinkOnClick}>
            <img src={require('../../assets/img/external-link.svg')} width="25px" height="25px" alt="" />
          </a>
        </Col> */}
      </Row>
    </Container>
  )
}

export default ProgressBar
